var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircleLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30.5,17.5A6.5,6.5,0,1,1,24,11,6.5,6.5,0,0,1,30.5,17.5ZM41.7118,33.3009a19.996,19.996,0,0,1-3.57,4.8412,20.245,20.245,0,0,1-1.51,1.365,19.9795,19.9795,0,0,1-25.264,0,20.245,20.245,0,0,1-1.51-1.365,20.0024,20.0024,0,1,1,31.854-4.8412ZM40,24A16,16,0,1,0,12.0649,34.6287l.7107-4.9743A1.9268,1.9268,0,0,1,14.683,28H20a3.85,3.85,0,0,0,4,4,3.85,3.85,0,0,0,4-4h5.317a1.9268,1.9268,0,0,1,1.9074,1.6544l.7107,4.9743A15.871,15.871,0,0,0,40,24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleLight);
export default __webpack_public_path__ + "static/media/userCircleLight.539141eccac714cd6c1cc69b35e73a3e.svg";
export { ForwardRef as ReactComponent };